import axios from './axios';

const AboutApi = {
    getByLocale: (locale) => axios.get(`/about/${locale}`),
    update: (locale, formData) =>
        axios.put(`/about/${locale}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),

};

export default AboutApi;
